import Navbar from "./Navbar";
import Footer from './Footer';
import { FaStar } from 'react-icons/fa';
import { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { BsDot } from "react-icons/bs";
import PRODUCTS_DATA from "./Productsdata";

export default function Viewproduct() {

    const [product, setProduct] = useState(null);
    const [images, setImages] = useState([]);
    const [mainImage, setMainImage] = useState("");

    const routerlocation = useLocation();
    const productId = new URLSearchParams(routerlocation.search).get("id");

    useEffect(() => {
        const foundProduct = PRODUCTS_DATA.find(
            (p) => p.id === productId
        );

        if (foundProduct) {
            setProduct(foundProduct);
            setImages(foundProduct.images || []);
            setMainImage(foundProduct.mainImage || foundProduct.images?.[0]);
        }
    }, [productId]);

    const minOrder = product?.Minorder || 1;

    const [quantity, setQuantity] = useState(minOrder);

    function formatSizes(sizes) {
        if (Array.isArray(sizes)) return sizes.join(", ");

        if (typeof sizes === "string") {
            const s = sizes.trim();
            // if already like "26, 28, 30" just normalize spaces
            if (s.includes(",")) return s.split(",").map(v => v.trim()).join(", ");
            // chunk "26283032" -> ["26","28","30","32"]
            const chunks = s.match(/\d{2}/g);
            return chunks ? chunks.join(", ") : s;
        }

        return "";
    }

    if (product) {

        return (
            <>
                <title>{product.ProductName.toString()}</title>
                <meta name="description" content="Browse our denim jeans collection for men and boys. Enquire online for bulk jeans supply, premium quality, and wholesale pricing." />
                <meta name="keywords" content="wholesale jeans collection, men’s jeans wholesale, boys jeans supplier, bulk denim jeans, premium denim wholesale, denim manufacturer India, wholesale jeans supplier, denim brand story, men’s jeans manufacturer, wholesale denim company, wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans,menswear near me, jeans near me, denims for men, denims for boys near me" />

                <meta property="og:title" content={product.ProductName.toString()} />
                <meta property="og:site_name" content="Hack98" />
                <meta property="og:url" content={`https://hack98.club/Viewproduct?id=${product.id}`} />
                <meta property="og:description" content="Browse our denim jeans collection for men and boys. Enquire online for bulk jeans supply, premium quality, and wholesale pricing." />
                <meta property="og:image" content="images /logoo.jpeg" />

                <meta name="twitter:card" content="app" />
                <meta name="twitter:site" content="hack98" />
                <meta name="twitter:description" content="Browse our denim jeans collection for men and boys. Enquire online for bulk jeans supply, premium quality, and wholesale pricing." />
                <meta name="twitter:app:country" content="India" />

                <div className="navbarrproducts">
                    <Navbar />
                </div>
                <div className="container product-detail-container my-5">
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            {mainImage && (
                                <img src={mainImage} className="img-fluid rounded mainimggg" alt="Main Display" />
                            )}
                            <div className="d-flex justify-content-center gap-2 mt-2 flex-wrap">
                                {images.map((img, i) => (
                                    <img
                                        src={img}
                                        alt={`Thumbnail ${i}`}
                                        onClick={() => setMainImage(img)}
                                        className="img-thumbnail"
                                        style={{ width: "80px", height: "80px", cursor: "pointer", border: mainImage === img ? "2px solid #007bff" : "1px solid #ddd" }}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <h1 className="h4 text-uppercase">{product.ProductName}</h1>

                            <div className="">
                                {[...Array(5)].map((_, index) => (
                                    <FaStar key={index} className="text-warning" />
                                ))}
                            </div>

                            <div className="mt-3">
                                <h2 className="h6">Sizes available-</h2>
                                <div className="d-flex gap-2 flex-wrap">
                                    {formatSizes(product.Sizes)}
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-12 mt-3 border border-2 p-2">
                                <h6>Minimum Quantity to be ordered: <span className="text-danger fw-bold">{product.Minorder}</span></h6>
                                <p className="text-muted fst-italic mb-0">Send us your enquiry now!!</p>
                            </div>

                            <div className="mt-3 d-flex align-items-center">
                                <span>🛡️ Durable & Comfortable Fit</span>
                            </div>
                            <div className="mt-3 d-flex align-items-center">
                                <span>💎 Premium Quality Hosiery Denim</span>
                            </div>
                            <div className="mt-3 d-flex align-items-center">
                                <span>🤝 Responsive Customer Support</span>
                            </div>

                            <Link to="/Distributor">
                                <button className="btn btn-primary mb-2 mt-3" >
                                    Enquire now
                                </button>
                            </Link>
                            <div class="mt-3">
                                <h6 class="fw-bold">Product Details:</h6>
                                <p>{(product.Description)}</p>
                                <ul class="list-unstyled mb-0">
                                    <li><BsDot size={25} /> Non Lycra</li>
                                    <li><BsDot size={25} /> Machine washable</li>
                                    {/* <li><BsDot size={25} /> Slim fit design</li> */}
                                    <li><BsDot size={25} /> Made in India</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                    <Footer />
                </div>
            </>
        )
    } else {
        return (
            <>
                <div className="navbarrrr">
                    <Navbar />
                </div>
                <div className="container product-detail-container my-5">
                    <div className="align-items-center text-center">
                        <h5 className="text-dark">
                            no product selected
                        </h5>
                    </div>
                </div>
                <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                    <Footer />
                </div>
            </>
        )
    }
}